import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Package } from "lucide-react";

const FreeAccompModal = ({ open, onOpenChange, accompagnements, formatPrice, onAdd }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-md" data-testid="free-accomp-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl text-yellow-400">
            <Package className="w-6 h-6" />
            Ajouter un Accompagnement Gratuit
          </DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2 py-4">
          {accompagnements.map((accomp) => (
            <Button
              key={accomp.id}
              onClick={() => onAdd(accomp.name)}
              variant="outline"
              className="h-auto py-3 border-yellow-500/30 hover:bg-yellow-500/20 text-left justify-start"
              data-testid={`free-accomp-btn-${accomp.id}`}
            >
              <div>
                <p className="text-white font-medium text-sm">{accomp.name}</p>
                <p className="text-yellow-400 text-xs">GRATUIT (au lieu de {formatPrice(accomp.price)} F)</p>
              </div>
            </Button>
          ))}
        </div>
        <Button
          variant="ghost"
          onClick={() => onOpenChange(false)}
          className="w-full text-slate-400 hover:text-white"
          data-testid="free-accomp-cancel-btn"
        >
          Annuler
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default FreeAccompModal;
